import { useEffect, useRef } from 'react';

import { CustomEventNames, EventTypes, logRBIEvent } from 'features/analytics';
import { logCommercePageView } from 'features/menu/utils/analytics';

import { MenuObjectTypes } from 'enums/menu';

const menuObjectTypes = new Set([
  MenuObjectTypes.PICKER.valueOf(),
  MenuObjectTypes.ITEM.valueOf(),
  MenuObjectTypes.COMBO.valueOf(),
]);

interface IUseLogMenuContentHook {
  loggedValues: {
    name: string;
    menuType: string;
    id: string;
  };
  pathname: string;
}

export const useLogMenuContent = ({ loggedValues, pathname }: IUseLogMenuContentHook) => {
  const loggedMenuObjectId = useRef<string | undefined>(undefined);

  const { menuType: _menuType, id } = loggedValues;
  const menuType = _menuType.toLowerCase();

  useEffect(() => {
    if (!id || loggedMenuObjectId.current === id) {
      return;
    }

    if (menuObjectTypes.has(menuType)) {
      logCommercePageView(loggedValues, { path: pathname });
    }

    if (menuType === MenuObjectTypes.SECTION) {
      logRBIEvent(
        {
          name: CustomEventNames.SECTION_SELECTED,
          type: EventTypes.Other,
          attributes: {
            name: loggedValues.name,
            sanityId: loggedValues?.id,
          },
        },
        { skipLoggingToBraze: true }
      );
    }
    loggedMenuObjectId.current = id;
  }, [id, loggedValues, menuType, pathname]);
};
